import api from '../api/axios';
import { jwtDecode } from 'jwt-decode';

const TOKEN_KEY = 'access_token';
const REFRESH_KEY = 'refresh_token';
export const USER_ROLE = 'user_role';
export const USER_PROFILE = 'user_profile';


export const login = async (credentials) => {
  const response = await api.post('/login/', credentials);
  localStorage.setItem(TOKEN_KEY, response.data.access);
  localStorage.setItem(REFRESH_KEY, response.data.refresh);
  localStorage.setItem(USER_ROLE, response.data.role);
  return response.data;
};

export const logout = async () => {
  const refresh = localStorage.getItem(REFRESH_KEY);
  await api.post('/logout/', { refresh });
  localStorage.clear();
};

export const forgotPassword = async (identifier) => {
  return await api.post('/forgot-password/', { identifier });
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getUser = () => {
  const token = getToken();
  return token ? jwtDecode(token) : null;
};
